import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DropdownManagerService {
  private dropdownState = new BehaviorSubject<string | null>(null);
  public dropdownState$ = this.dropdownState.asObservable();

  constructor() { }

  // Call this when a dropdown is opened
  openDropdown(dropdownId: string) {
    this.dropdownState.next(dropdownId);
  }

  // Call this when a dropdown is closed
  closeDropdown() {
    this.dropdownState.next(null);
  }

  // Get the current open dropdown ID
  getCurrentDropdownId(): string | null {
    return this.dropdownState.value;
  }
}
